import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const OrganizationService = {
  createOrganization: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.ORGANIZATION.CREATEORGANIZATION,
      data
    );
    return response;
  },

  updateOrganization: async (id, data) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.ORGANIZATION.UPDATEORGANIZATION,
      {
        id,
      }
    );
    const response = await api.patch(endpoint, data);
    return response;
  },

  listAllOrganizations: async (pageNo, pageSize) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.ORGANIZATION.LISTALLORGANIZATIONS,
      {
        pageNo,
        pageSize,
      }
    );
    const response = await api.get(endpoint);
    return response;
  },
  getRMList: async () => {
    const response = await api.get(API_ENDPOINTS.ORGANIZATION.GETRMLIST);
    return response;
  },
  assignRM: async (organizationId, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.ORGANIZATION.ASSIGNRM, {
      id: organizationId,
    });
    const response = await api.post(endpoint, data);

    return response;
  },

  getOrganizationUsers: async (organizationId, pageNo = 1, pageSize = 10) => {
    const endpoint = createEndpoint(
      API_ENDPOINTS.ORGANIZATION.GETORGANIZATIONUSERS,
      {
        organizationId,
        pageNo,
        pageSize,
      }
    );
    const response = await api.get(endpoint);
    return response;
  },

  registerOrganizationUser: async (data) => {
    const response = await api.post(
      API_ENDPOINTS.USER.REGISTER_ORGANIZATION_USER,
      data
    );
    return response;
  },

  deactivateUser: async (organizationId, userId) => {
    // Dummy endpoint - replace with actual endpoint when provided
    const endpoint = `/internal/admin/organizations/${organizationId}/users/${userId}/deactivate`;
    const response = await api.post(endpoint);
    return response;
  },
};
